var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('default-button',{attrs:{"primary":"","loading":_vm.swappingEngraving},nativeOn:{"click":function($event){$event.preventDefault();return _vm.swapEngraving.apply(null, arguments)}}},[_vm._v("\n    Swap Engraving\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }